import fetch from 'auth/FetchInterceptor'
import generateBoundary from "./utils";

const HelpDeskService = {
	_url: '/rest/v1/dealer/data/helpdesk',


  async _getResource(url) {
    const resp = await fetch({
      url: `${this._url}${url}`,
      method: 'get'
    });
    return resp.data;
  },
  async _setResource(url, {
    method='post',
    data,
    headers = {}}
  ) {
    const resp = await fetch({
      url: `${this._url}${url}`,
      method: method,
      data,
      headers
    });
    return resp.data;
  },
  async _optResource(url) {
    const resp = await fetch({
      url: `${this._url}${url}`,
      method: 'options'
    });
    return resp.data;
  },


  async getHelpDeskList(params) {

    const {
      pageId = null,
      pageSize = 50,
      filters = {},
      search = ''
    } = params;
    let urlParam = '';
    let paramItem = ''
    if (Number.isInteger(pageId)) {
      paramItem = !urlParam ? '?' : '&';
      paramItem += `page=${pageId}`;
      urlParam += paramItem;
    };
    if (Number.isInteger(pageSize)) {
      paramItem = !urlParam ? '?' : '&';
      paramItem += `page_size=${pageSize}`;
      urlParam += paramItem;
    };
    if (search) {
      paramItem = !urlParam ? '?' : '&';
      paramItem += `search=${search}`;
      urlParam += paramItem;
    }

    if (typeof filters === 'object') {
      for (let i in filters) {
        if (filters.hasOwnProperty(i)) {
          paramItem = !urlParam ? '?' : '&';
          paramItem += `${i}=${filters[i]}`;
          urlParam += paramItem;
        }
      }
    }

    const url = `/helpdesk-list${urlParam}`;

    const resp = await this._getResource(url);
    return {
      pageSize: pageSize,
      totalCount: resp.count,
      data: resp.results
    };
  },


  async optCreateTicket() {
    const url = `/create-ticket`;
    const resp = await this._optResource(url);
    return resp.results;
  },
  async createTicket(data) {

    const url = `/create-ticket`;
    const resp = await this._setResource(url,
      {
        data,
        headers: {
          'Content-Type': `multipart/form-data; boundary=${generateBoundary()}`,
        },
      });

    return {
      data: resp.results
    };
  },

  async getTicket(id) {

    const url = `/${id}/get-ticket`;
    const resp = await this._getResource(url);

    return {
      data: resp.results
    };
  },

  async followUpMessage(id, data) {

    const url = `/${id}/follow-up-message`;
    const resp = await this._setResource(url,
      {
        data,
        headers: {
          'Content-Type': `multipart/form-data; boundary=${generateBoundary()}`,

        },
      });

    return {
      data: resp.result
    };
  },



  async getHelpDeskNotificationList() {
    const url = `/helpdesk-notification-list`;

    const resp = await this._getResource(url);
    return {
      data: resp.results
    };
  },

  async getTotalUnreadMessagesCount() {
    const url = `/get-total-unread-messages-count`;

    const resp = await this._getResource(url);
    return {
      data: resp?.results?.['total unread messages count'] ?? 0
    };
  },

}
export default HelpDeskService;


